<div class="app-main-view" id="app-main-viewer">

<div id="app-viewer" class="app-viewer-wrapper app-viewer-{{bookService.viewerMode}}" (mousemove)="onMouseMove()" (click)="onMouseMove()">
  <app-viewer-controls [context]="'scan'" *ngIf="bookService.pageAvailable && selectionStateOff()" [class.hide-on-inactivity]="hideOnInactivity"></app-viewer-controls>


  <!-- <div class="app-text-mode-wrapper" *ngIf="bookService.textMode && bookService.pageAvailable">
      <div class="app-text-mode app-font-size-{{textZoom}}">
            <div [innerHtml]="textContent"></div>
      </div>
  </div> -->

<div class="app-help-message" *ngIf="showHelpMessage()">
      <mat-icon (click)="cancelSelection()"
            [matTooltip]="'viewer_page.region_selection_cancel' | translate">
            cancel
      </mat-icon>
      <span>{{ "viewer_page.region_selection_help" | translate }}</span>
</div>  


  <mat-spinner *ngIf="bookService.isPageLoading() || imageLoading" 
               class="medium-centered-spinner" 
               [strokeWidth]="3"
               [diameter]="40">
  </mat-spinner>
  


  <div id="selectionmenu">

      <mat-icon (click)="onShowTextSelection()"
            [matTooltip]="'viewer_page.region_text' | translate"
            *ngIf="showSelectText()"
            matTooltipPosition="right"
            [class.app-inactive]="!selectTextEnabled() || bookService.serviceLoading">
            title
      </mat-icon>

      <mat-icon (click)="onShowImageCrop()"
            [matTooltip]="'viewer_page.region_image' | translate"
            matTooltipPosition="right"
            [class.app-inactive]="!imageCropEnabled()"
            *ngIf="showImageCrop()">
            image
      </mat-icon>

      <mat-icon (click)="onShareSelection()"
            matTooltipPosition="right"
            [matTooltip]="'viewer_page.region_share' | translate">
            share
      </mat-icon>

      <mat-icon (click)="onReadSelection()"
            matTooltipPosition="right"
            *ngIf="aiActionsAvailable()"
            class="app-type-ai"
            [class.app-inactive]="tts.inProgress()"
            [matTooltip]="'viewer_page.region_read' | translate">
            record_voice_over
      </mat-icon>

      <mat-icon (click)="onTranslateSelection()"
            matTooltipPosition="right"
            *ngIf="aiActionsAvailable()"
            class="app-type-ai"
            [class.app-inactive]="bookService.serviceLoading"
            [matTooltip]="'viewer_page.region_translate' | translate">
            translate
      </mat-icon>

      <mat-icon (click)="onSummarizeSelection()"
            matTooltipPosition="right"
            *ngIf="aiActionsAvailable()"
            class="app-type-ai"
            [class.app-inactive]="bookService.serviceLoading"
            [matTooltip]="'viewer_page.region_summarize' | translate">
            list
      </mat-icon>

      <mat-icon (click)="onSimilaritySearchSelection()"
            matTooltipPosition="right"
            *ngIf="similaritySearchAvailable()"
            class="app-type-ai"
            [class.app-inactive]="bookService.serviceLoading"
            [matTooltip]="'Najít podobné'">
            search
      </mat-icon>

      <mat-icon (click)="cancelSelection()"
            matTooltipPosition="right"
            class="app-type-cancel"
            [matTooltip]="'common.close' | translate">
            close
      </mat-icon>

  </div>




  <!-- <div id="selectionmenu" style="display: none; position: absolute; background-color: red; border-radius: 10px; width: 10px; height: 10px;">

  </div> -->
</div>





<div id="app-text-viewer" (mousemove)="onMouseMove()" class="app-text-viewer-wrapper app-viewer-{{bookService.viewerMode}}">
      
      
      <div *ngIf="bookService.pageAvailable" class="app-text-mode app-font-size-{{textZoom}}">
            <div [innerHtml]="textContent"></div>
      </div>

      <div class="app-text-view-header">

            <div class="app-view-toggle">



            <mat-icon
                  [matTooltip]="'viewer_page.page_text' | translate"
                  (click)="enterTextMode()"
                  [class.app-inactive]="bookService.serviceLoading"
                  [class.app-active]="bookService.viewerMode == 'text'"
                  class="app-view-mode">
                  title
            </mat-icon>

            <mat-icon
                  [matTooltip]="'Zobrazit originál'"
                  (click)="enterScanMode()"
                  [class.app-inactive]="bookService.serviceLoading"
                  [class.app-active]="bookService.viewerMode == 'scan'"
                  class="app-view-mode">
                  image
            </mat-icon>

            <mat-icon
                  [matTooltip]="'Porovnat s originálem'"
                  style="transform: rotate(180deg);"
                  (click)="enterSplitMode()"
                  *ngIf="bookService.isActionAvailable('split_mode')"
                  [class.app-inactive]="bookService.serviceLoading"
                  [class.app-active]="bookService.viewerMode == 'split'"
                  class="app-view-mode">
                  vertical_split
            </mat-icon>

            </div>

            <div *ngIf="textLanguage" class="app-dropdown app-language" [matMenuTriggerFor]="languagesMenu">
                  <img [alt]="languageService.getLanguageName(textLanguage)"  src="assets/img/flag_{{textLanguage}}.png" >
                  <mat-icon>keyboard_arrow_down</mat-icon>
            </div>
      </div>


      <app-viewer-controls [context]="'text'" *ngIf="bookService.pageAvailable && selectionStateOff()" [class.hide-on-inactivity]="hideOnInactivity"></app-viewer-controls>


      <mat-spinner *ngIf="bookService.isPageLoading() || textContentLoading" 
            class="medium-centered-spinner" 
            [strokeWidth]="3"
            [diameter]="40">
      </mat-spinner>



  </div>





  <div class="app-sound-controls" *ngIf="tts.inProgress()"
      [class.hide-on-inactivity]="hideOnInactivity && !tts.isLoading()">


      <mat-icon class="app-rotate-icon" 
            *ngIf="tts.isLoading()">
            hourglass_top
      </mat-icon>


      <ng-container *ngIf="!tts.isLoading()">
            <mat-icon
                  *ngIf="!tts.paused()"
                  [matTooltip]="'viewer_page.read_pause' | translate"
                  matTooltipPosition="below"
                  (click)="tts.pause()">
                  pause
            </mat-icon>

            <mat-icon *ngIf="tts.paused()"
                  [matTooltip]="'viewer_page.read_resume' | translate"
                  matTooltipPosition="below"
                  (click)="tts.resume()">
                  play_arrow
            </mat-icon>

            <mat-icon
                  [matTooltip]="'viewer_page.read_stop' | translate"
                  matTooltipPosition="below"
                  (click)="tts.stop()">
                  stop
            </mat-icon>

            <!-- <mat-icon *ngIf="tts.continuing"
                  [matTooltip]="'viewer_page.read_next' | translate"
                  matTooltipPosition="below"
                  (click)="tts.skipNext()">
                  skip_next
            </mat-icon> -->

            <mat-icon
                  [matTooltip]="'common.settings' | translate"
                  matTooltipPosition="below"
                  (click)="tts.openSettings()">
                  settings
            </mat-icon>
      </ng-container>

</div>


<mat-icon class="app-rotate-icon app-main-service-loader" *ngIf="bookService.serviceLoading">hourglass_top</mat-icon>

<div class="app-selection-actions" 
      [class.hide-on-inactivity]="hideOnInactivity"
      *ngIf="showPageActions()">


            <mat-icon
                  class="app-selection app-main-selection app-hide-on-hover">
                  auto_awesome
            </mat-icon>

            <mat-icon
                  [matTooltip]="'viewer_page.region_selection' | translate"
                  matTooltipPosition="left"
                  *ngIf="bookService.viewerMode != 'text'"
                  (click)="enterSelectionMode()"
                  class="app-selection">
                  highlight_alt
            </mat-icon>


            <mat-icon
                  [matTooltip]="'viewer_page.page_text' | translate"
                  matTooltipPosition="left"
                  (click)="enterTextMode()"
                  *ngIf="bookService.viewerMode == 'scan'"
                  [class.app-inactive]="bookService.serviceLoading || !bookService.isActionEnabled('text')"
                  class="app-selection">
                  title
            </mat-icon>

            <ng-container *ngIf="aiActionsAvailable()">
                  <div class="app-reading-wrapper">
                        <mat-icon
                              [matTooltip]="'viewer_page.page_read' | translate"
                              matTooltipPosition="left"
                              (click)="onReadPage()"
                              [class.app-inactive]="tts.inProgress() || bookService.serviceLoading"
                              class="app-selection app-type-ai">
                              record_voice_over
                        </mat-icon>
                        <div class="app-reading-setting">
                              <mat-icon
                              [matTooltip]="'common.settings' | translate"
                              matTooltipPosition="left"
                              (click)="openTtsSettings()"
                              class="app-selection">
                              settings
                        </mat-icon>
                        </div>
                  </div>

                  <mat-icon
                        [matTooltip]="'viewer_page.page_translate' | translate"
                        matTooltipPosition="left"
                        (click)="onTranslatePage()"
                        [class.app-inactive]="bookService.serviceLoading"
                        *ngIf="!textLanguage"
                        class="app-selection app-type-ai">
                        translate
                  </mat-icon>

                  <!-- <mat-icon
                        [matTooltip]="'viewer_page.page_translate' | translate"
                        matTooltipPosition="left"
                        (click)="onCancelTranslatePage()"
                        [class.app-inactive]="bookService.serviceLoading"
                        *ngIf="textLanguage"
                        class="app-selection app-type-cancel">
                        translate
                  </mat-icon> -->

                  <mat-icon
                        [matTooltip]="'viewer_page.page_summarize' | translate"
                        matTooltipPosition="left"
                        (click)="onSummarizePage()"
                        [class.app-inactive]="bookService.serviceLoading"
                        class="app-selection app-type-ai">
                        list
                  </mat-icon>

                  <mat-icon
                        *ngIf="alphaTestAiActionsEnabled()"
                        [matTooltip]="'Zeptat se AI ke stránce'"
                        matTooltipPosition="left"
                        (click)="onChatPage()"
                        [class.app-inactive]="bookService.serviceLoading"
                        class="app-selection app-type-ai">
                        chat_bubble
                  </mat-icon>

                  <mat-icon
                        *ngIf="alphaTestAiActionsEnabled()"
                        [matTooltip]="'Zeptat se AI k celému dokumentu'"
                        matTooltipPosition="left"
                        (click)="onChatDoc()"
                        [class.app-inactive]="bookService.serviceLoading"
                        class="app-selection app-type-ai">
                        chat
                  </mat-icon>

                  <mat-icon
                        *ngIf="makariusEnabled()"
                        [matTooltip]="'Najít podobné notové zápisy'"
                        matTooltipPosition="left"
                        (click)="onMakariusSimilaritySearch()"
                        [class.app-inactive]="bookService.serviceLoading"
                        class="app-selection app-type-ai">
                        music_note
                  </mat-icon>


            </ng-container>

</div>








<div class="app-licence-window-wrapper" *ngIf="bookService.isPageInaccessible()">
      <app-licence-window [licences]="bookService.licences"></app-licence-window>
</div>


  <app-alert *ngIf="bookService.isPageFailure()"
              type="danger"
              label="alert.error"
              message="alert.failed_to_load_image">
  </app-alert>

<div class="app-alert-not-found" *ngIf="bookService.noFulltextResults()">
      <div class="app-message">{{ "alert.book_no_results" | translate }}</div>    
      <button (click)="bookService.fulltextChanged('')" mat-flat-button color="primary">{{ "alert.cancel_fulltext" | translate }}</button>
</div>


<div *ngIf="bookService.licence && licences.bar(bookService.licence)" class="app-licence-bar">
      <span class="app-info">{{ licences.label(bookService.licence) }}</span>
      <span class="app-user">
            <ng-container *ngIf="authService.isLoggedIn()">{{ today() }} | {{ authService.getUserId() || authService.getUserName() }}</ng-container>
            
      </span>
  </div>



  <span *ngIf="controlsService.leftPanelVisible && !controlsService.fullscreenEnabled()"
        class="app-handle app-left-handle valign-wrapper hide-on-small-only" 
        tabindex="0"
        (click)="controlsService.hideLeftPanel()" 
        [matTooltip]="'view_controls.tooltip_hide_left' | translate">
        <mat-icon>arrow_left</mat-icon>
  </span>

  <span *ngIf="!controlsService.leftPanelVisible && !controlsService.fullscreenEnabled()"
        class="app-handle app-left-handle valign-wrapper hide-on-small-only" 
        tabindex="0"
        (click)="controlsService.showLeftPanel()" 
        [matTooltip]="'view_controls.tooltip_show_left' | translate">
        <mat-icon>arrow_right</mat-icon>
  </span>

  <span *ngIf="controlsService.rightPanelVisible && !controlsService.fullscreenEnabled()"
        class="app-handle app-right-handle valign-wrapper hide-on-small-only" 
        tabindex="0"
        (click)="controlsService.hideRightPanel()" 
        [matTooltip]="'view_controls.tooltip_hide_right' | translate">
        <mat-icon>arrow_right</mat-icon>
  </span>

  <span *ngIf="!controlsService.rightPanelVisible && !controlsService.fullscreenEnabled()"
        class="app-handle app-right-handle valign-wrapper hide-on-small-only" 
        tabindex="0"
        (click)="controlsService.showRightPanel()" 
        [matTooltip]="'view_controls.tooltip_show_right' | translate">
        <mat-icon>arrow_left</mat-icon>
  </span>




  </div>



  <mat-menu #languagesMenu="matMenu" xPosition="after" class="app-languages-menu">
      <ul [class.app-4-cols]="languages.length >= 6">
        <li class="app-dropdown-item" mat-menu-item tabindex="0" *ngFor="let lang of languages" (keydown.enter)="closeMenu()" (click)="onLanguageChanged(lang)" role="button">
          <div class="app-language">
            <img src="assets/img/flag_{{lang}}.png">
            <div class="app-language-name">{{ languageService.getLanguageName(lang) }}</div>
          </div>
        </li>
        <li class="app-dropdown-item app-dropdown-cancel-lang" mat-menu-item tabindex="0" (keydown.enter)="closeMenu()" (click)="onCancelTranslatePage()" role="button">
            <div class="app-language">
                  <div class="app-language-name" style="font-size: 13px; text-align: center;">{{ 'viewer_page.cancel_translation' | translate }} </div>
            </div>
        </li>
      </ul>
</mat-menu>